module.exports = __webpack_public_path__ + "static/img/red_envelope_bg.9570c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red_envelope_bg.png
// module id = LZ33
// module chunks = 1